import MuiTableCell, { TableCellProps as MuiTableCellProps } from '@mui/material/TableCell';

export type TableCellProps = MuiTableCellProps;

export const TableCell = (props: TableCellProps) => {
  return <MuiTableCell {...props} />;
};
